export const AdminLeadOwnerDashboards = {
  AdminLeadOwnerDashboards: {
    permissionsId: "d78ea1b1-559e-492d-8870-08dc0129f7d6",
    permissionsName: "Lead Owner",
    description: null,
    componentsId: null,
    components: null
  },
};
